import { DOWNLOAD_OPTIONS } from "../actions/csvDownloadAction";

const csvDownloadReducer = (state = {}, action) => {
    switch (action.type) {
        case DOWNLOAD_OPTIONS:
            return state;
        default:
            return state;
    }
};

export default csvDownloadReducer;
